import React from "react";
import MetaTags from "react-meta-tags";
import { useTranslation } from "react-i18next";
import NasHeader from "../../layouts/_nas/NasHeader";
import NasFooter from "../../layouts/_nas/NasFooter";
import Breadcrumbs from "../../layouts/Breadcrumbs";
import NasPaymentPageContent from "../../sections/_nas/NasPaymentPageContent";

const NasPaymentPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <MetaTags>
        <title>Holy Spirit Church | {t("_payment_page_title")}</title>
        <meta name="description" content={t("_payment_summary_desc")} />
      </MetaTags>
      <NasHeader />
      <Breadcrumbs breadcrumb={{ pagename: t("_payment_page_title") }} />
      <NasPaymentPageContent />
      <NasFooter />
    </>
  );
};

export default NasPaymentPage;
